import { Pointers } from "@opendaw/studio-enums";
import { Arrays } from "@opendaw/lib-std";
import { ModuleConnectionAdapter } from "./connection";
export var Direction;
(function (Direction) {
    Direction["Input"] = "input";
    Direction["Output"] = "output";
})(Direction || (Direction = {}));
export class ModuleConnectorAdapter {
    static create(boxAdapters, field, direction, name) {
        return new ModuleConnectorAdapter(boxAdapters, field, direction, name ?? field.fieldName);
    }
    #boxAdapters;
    #field;
    #direction;
    #name;
    constructor(boxAdapters, field, direction, name) {
        this.#boxAdapters = boxAdapters;
        this.#field = field;
        this.#direction = direction;
        this.#name = name;
    }
    matches(other) {
        return this.direction !== other.direction && this.field.pointerRules.accepts
            .some(accepts => other.field.pointerRules.accepts
            .some(type => type === accepts));
    }
    get connections() {
        if (this.#field.pointerHub.isEmpty()) {
            return Arrays.empty();
        }
        return this.#field.pointerHub.filter(Pointers.VoltageConnection)
            .map(({ box }) => this.#boxAdapters.adapterFor(box, ModuleConnectionAdapter));
    }
    get field() { return this.#field; }
    get address() { return this.#field.address; }
    get direction() { return this.#direction; }
    get name() { return this.#name; }
    toString() {
        return `{ModuleConnectorAdapter address: ${this.#field.address.toString()}, direction: ${this.#direction}}`;
    }
}
